module.exports = __webpack_public_path__ + "static/media/accounts-room.81f820f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accounts-room.jpg
// module id = 77
// module chunks = 3